import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { useAuth } from "../../../Context/AuthProvider";
import axios from "axios";
import { url } from "../../../Constant";
import { toast } from "react-toastify";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../../Utils/PermissionFunctions";

const CreateIVR = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    userfile: "",
    vpbx_id: auth.vpbx_id,
    template_name: auth.template_name,
  });
  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "zip") {
      setFileUploadError("Please upload zip format file");
      setSubmittedData({
        ...submittedData,
        userfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        userfile: file,
      });
    }
  };
  const createIvr = () => {
    setErrorEnable(true);
    setLoader(true);
    var formData = new FormData();

    formData.append("vpbx_id", submittedData.vpbx_id);
    formData.append("userfile", submittedData.userfile);
    formData.append("template_name", submittedData.template_name);

    if (fileUploadError === "" && submittedData.userfile !== "") {
      let api = "";
      if (auth.role === "2") {
        api = "store-ivrflow";
      } else {
        api = "user-store-ivrflow";
      }

      axios
        .post(url + api, formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "IVR Flow Added") {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/ivr-flow";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>

            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("ivr-flow") ? (
                      <li
                        onClick={() => navigate("/ivr-flow", { replace: true })}
                      >
                        <a href="#">IVR flow</a>
                      </li>
                    ) : null}

                    {auth.role === "2" || checkPermissions("extensions") ? (
                      <li
                        onClick={() =>
                          navigate("/extensions", { replace: true })
                        }
                      >
                        <a href="#">Extensions</a>
                      </li>
                    ) : null}

                    {auth.role === "2" || checkPermissions("Forwarding") ? (
                      <li
                        onClick={() =>
                          navigate("/call-forwarding", { replace: true })
                        }
                      >
                        <a href="#">Forwarding</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("conferencing") ? (
                      <li
                        onClick={() =>
                          navigate("/call-conferencing", { replace: true })
                        }
                      >
                        <a href="#">Conferencing</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("list-manager") ? (
                      <li
                        onClick={() =>
                          navigate("/list-manager", { replace: true })
                        }
                      >
                        <a href="#">List manager</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("hours") ? (
                      <li onClick={() => navigate("/hour", { replace: true })}>
                        <a href="#">Hours</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("queue") ? (
                      <li onClick={() => navigate("/queue", { replace: true })}>
                        <a href="#">Queue</a>
                      </li>
                    ) : null}
                    {auth.role === "2" ? (
                      <li onClick={() => navigate("/prompt", { replace: true })}>
                        <a href="#">prompt</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("ivr-flow") ? (
                  <li>
                    <div className="dashboardWrp">
                      <div className="uk-container uk-container-small">
                        <div className="dashboardTop">
                          <div uk-grid="" className="uk-grid">
                            <div className="uk-width-2-3">
                              <div className="dashboardIntro">
                                <h3>Create IVR</h3>
                              </div>
                            </div>
                          </div>

                          <form action="javascript:void(0);">
                            <div className="formCreateMain">
                              <div className="uk-grid uk-grid-small">
                                <div className="uk-width-1-1@m uk-margin-top">
                                  <label>
                                    <b>Upload IVR flow</b>
                                  </label>
                                  <span className="fileDisc">
                                    Only .zip ﬁles.900kb max ﬁle size.
                                  </span>
                                  <div className="uk-margin-bottom">
                                    <div uk-form-custom="target: true">
                                      <input
                                        type="file"
                                        aria-label="Custom controls"
                                        accept=".zip"
                                        onChange={(e) => handleFile(e)}
                                      />
                                      <input
                                        className="uk-input uk-form-width-medium"
                                        type="text"
                                        placeholder="Choose files"
                                        aria-label="Custom controls"
                                        disabled
                                      />
                                      {errorEnable &&
                                        submittedData.userfile === "" && (
                                          <div className="formErrors">
                                            Please upload file
                                          </div>
                                        )}
                                      {errorEnable &&
                                        fileUploadError !== "" && (
                                          <div className="formErrors">
                                            {fileUploadError}
                                          </div>
                                        )}
                                    </div>
                                    {/* <button className="uk-button fileUploadBtn uk-button-default">Submit</button> */}
                                  </div>
                                  <a
                                    href={
                                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/default.zip"
                                    }
                                    className="DownloadFileBtn"
                                  >
                                    Download sample file
                                  </a>
                                </div>

                                {(auth.role === "2" ||
                                  (auth.role === "3" &&
                                    checkIndividualPermission(
                                      "ivr-flow",
                                      "read_and_write"
                                    ))) && (
                                  <div className="uk-width-1-1@m uk-float-right">
                                    <div className="formActionBtn uk-text-right">
                                      {/* <button className="whiteBtn">Cancel</button> */}
                                      <button
                                        className="pinkBtn"
                                        onClick={() => createIvr()}
                                      >
                                        {loader ? (
                                          <div uk-spinner="" className="loader">
                                            Adding
                                          </div>
                                        ) : (
                                          "Save"
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : null}

                {auth.role === "2" || checkPermissions("extensions") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("Forwarding") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("conferencing") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("list-manager") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("hours") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("queue") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" ? <li></li> : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CreateIVR;
